(ns frontend.view.settings2.decisions.events
  (:require
   [re-frame.core :as rf]
   [frontend.view.settings2.decisions.sub :as sub]
   [frontend.actions.tenant :as tenant-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.state.current-session :as session]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]))


(defn save-decision-configuration!
  [decision-config success-cb error-cb]
  (let [decision-config-str (pr-str decision-config)
        tenant-id @session/tenant-id]
    (tenant-actions/*->update! tenant-id
                               :tenant/decision-configuration
                               decision-config-str
                               success-cb
                               error-cb)))

(defn create-investment-reservation-type!
  [data on-success on-error]
  (let []
    (entity-actions/*->create data
                              on-success
                              on-error)))

(defn delete-investment-reservation-type!
  [entity-id on-success on-error]
  (entity-actions/*->disable! entity-id
                              on-success
                              on-error))

(rf/reg-event-db
 ::set-show-archived-investment-reservation-types
 (fn [db [_ show?]]
   (assoc db ::sub/show-archived-investment-reservation-types? show?)))

(rf/reg-event-db
 ::close-submit-error-dialog
 (fn [db _]
   (dissoc db ::sub/submit-error-dialog)))


(defn submit-success
  [{:keys [db]} [_ label]]
  {:db db
   ::toast/success label})
(defn submit-error
  [{:keys [db]} [_ title resp]]
  (let [{:keys [error message]} resp
        description (case message
                      :investment-reservation-type-in-use
                      "Could not delete investment reservation type because it is used in decisions."
                      nil)
        error-dialog-data {:open?       true
                           :title       title
                           :description description}]
    {:db (assoc db ::sub/submit-error-dialog error-dialog-data)}))

(rf/reg-event-fx ::submit-success submit-success)
(rf/reg-event-fx ::submit-error submit-error)


(rf/reg-event-fx
 ::archive-reservation-type
 (fn [{:keys [db]} [_ entity-id]]
   (let []
     {:db       db
      ::ws/send {:id         :common/archive
                 :body       {:entity-id entity-id}
                 :on-success [::submit-success "Archived"]
                 :on-error   [::submit-error "Error archiving!"]}})))

(rf/reg-event-fx
 ::unarchive-reservation-type
 (fn [{:keys [db]} [_ entity-id]]
   (let []
     {:db       db
      ::ws/send {:id         :common/unarchive
                 :body       {:entity-id entity-id}
                 :on-success [::submit-success "Unarchived"]
                 :on-error   [::submit-error "Error unarchiving!"]}})))

(rf/reg-event-fx
 ::disable-reservation-type
 (fn [{:keys [db]} [_ entity-id]]
   (let []
     {:db       db
      ::ws/send {:id         :investment-reservation-type/disable!
                 :body       {:entity-id entity-id}
                 :on-success [::submit-success "Deleted"]
                 :on-error   [::submit-error "Error while deleting!"]}})))





